import { gql } from 'apollo-boost';

export const CREATE_CUSTOMER = gql`
  mutation doCreateCustomer($data: CustomerInput!) {
    createCustomer(data: $data) {
      id
      region
      firstName
      lastName
      email
      matchAddress
      shippingAddress {
        id
        firstName
        lastName
        line1
        line2
        city
        state
        postalCode
        country
        phone
      }
      billingAddress {
        id
        firstName
        lastName
        line1
        line2
        city
        state
        postalCode
        country
        phone
      }
    }
  }
`;
